import httpRequest from '../../utils/request';

// Obtener configuración fiscal
const getFiscalConfig = async () => {
  // Add timestamp query param to bust caches (prevent 304 cached responses in dev browsers)
  const response = await httpRequest.get('/fiscal/config', { params: { _t: Date.now() } });
  return response.data;
};

// Guardar configuración fiscal
const saveFiscalConfig = async (data) => {
  const response = await httpRequest.post('/fiscal/config', data);
  return response.data;
};

// Subir credenciales AFIP
const uploadAfipCredentials = async (formData) => {
  const response = await httpRequest.post('/fiscal/credentials', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
  return response.data;
};

// Agregar punto de venta
const addPuntoVenta = async (data) => {
  const response = await httpRequest.post('/fiscal/punto-venta', data);
  return response.data;
};
const updatePuntoVenta = async (data) => {
  const response = await httpRequest.put('/fiscal/punto-venta', data);
  return response.data;
};

// Actualizar solo el ambiente AFIP
const updateAfipAmbiente = async (data) => {
  const response = await httpRequest.put('/fiscal/ambiente', data);
  return response.data;
};

// Eliminar punto de venta
const deletePuntoVenta = async (numero) => {
  const response = await httpRequest.delete('/fiscal/punto-venta', { params: { numero } });
  return response.data;
};

// Actualizar configuración de facturación
const updateFacturacionConfig = async (data) => {
  const response = await httpRequest.put('/fiscal/facturacion-config', data);
  return response.data;
};

// Obtener estado de configuración
const getFiscalStatus = async () => {
  const response = await httpRequest.get('/fiscal/status');
  return response.data;
};

// Re-bloquear locks desde cliente tenant (solo permite setear true)
const releaseLocks = async (data = {}) => {
  const response = await httpRequest.post('/fiscal/locks', data);
  return response.data;
};

const getFiscalDiagnostics = async () => {
  const response = await httpRequest.get('/fiscal/diagnostics');
  return response.data;
};

const getPadronByCuit = async (cuit) => {
  const response = await httpRequest.get(`/fiscal/padron/${cuit}`);
  return response.data;
};

// Listar archivos disponibles para descarga
const getFiscalFiles = async () => {
  const response = await httpRequest.get('/fiscal/files');
  return response.data;
};

// Descargar carpeta fiscal como ZIP (devuelve blob)
const getFiscalFilesZip = async () => {
  const response = await httpRequest.get('/fiscal/files/zip', { responseType: 'blob' });
  return response.data;
};

const fiscalService = {
  getFiscalConfig,
  saveFiscalConfig,
  uploadAfipCredentials,
  addPuntoVenta,
  updatePuntoVenta,
  updateFacturacionConfig,
  getFiscalStatus,
  releaseLocks,
  getFiscalDiagnostics,
  getPadronByCuit
  ,
  updateAfipAmbiente,
  deletePuntoVenta,
  getFiscalFiles
  ,
  getFiscalFilesZip
};

export default fiscalService;
